<script setup lang="ts">
import type {Home} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  data: Populated<Home>['team']
}>()

const lp = useLocalePath()
</script>

<template>
  <Container
    class="screen-content flex flex-col-reverse items-end px-0 py-16 sm:py-8 md:space-x-0 md:py-16 lg:flex-row"
  >
    <div class="flex w-full flex-col space-y-8 px-8 py-8 md:pl-16 lg:w-1/2 xl:w-1/3">
      <div>
        <Heading as="h2" size="caption" class="mb-2">{{ data.title }}</Heading>
        <Heading as="h3" size="medium" class="mb-4">{{ data.headline }}</Heading>

        <Paragraph size="medium">
          {{ data.body }}
        </Paragraph>
      </div>

      <div v-if="data.stats" class="space-y-8">
        <div class="space-y-4">
          <article v-for="stat of data.stats" :key="stat.title" class="space-y-1">
            <Heading as="h4" size="small">{{ stat.title }}</Heading>
            <Paragraph size="normal">{{ stat.data }}</Paragraph>
          </article>
        </div>
      </div>

      <div lass="flex justify-start">
        <Action intent="main" size="normal" as="link" :to="lp('/company')" class="w-fit">
          {{ $t('home.team.action.label') }}
        </Action>
      </div>
    </div>

    <div v-if="data.image" class="h-full w-full px-2 lg:w-1/2 lg:pr-4 xl:w-2/3 xl:pr-2">
      <div class="aspect-[16:10] rounded-lg bg-gray-50 p-2 bordershadow-gray lg:w-[clamp(100%,45vw,140%)]">
        <NuxtPicture
          v-bind="resolveMediaProps(data.image)"
          format="webp"
          fit="cover"
          width="1600"
          height="1000"
          quality="80"
          sizes="xs:360px sm:480px md:720px lg:800px xl:1200px"
          :img-attrs="{class: 'w-full h-full rounded bordershadow-main-light object-cover', fetchpriority: 'high'}"
        />
      </div>
    </div>
  </Container>
</template>
